export const displayUsername = (name: string | null | undefined): string =>
  name || "***"
